/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive that provides a callback when a containing ui-select dropdown closes.
 */
angular.module('bulbApp.utilsModule')

.directive('bulbOnUiSelectClose', bulbOnUiSelectClose);

function bulbOnUiSelectClose() {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      scope.$on('uis:close', function () {
        // FUTURE: Find a best-practices way to avoid the "$apply already in progress" error
        if (!scope.$root.$$phase) {
          scope.$apply(attrs.bulbOnUiSelectClose);
        }
      });
    }
  };
}
